import React from 'react';
import { TextInput } from '@youngcapital/component-library';
import { validPassword } from '@youngcapital/validations';
import { asFieldset, FIELDSET_PROPTYPES } from '../asFieldset';
import { AppContext } from '../../../AppContext';
import { SIGNUP_FOR_MAPPING } from '../../../services/constants';
import { whenFieldHasValueHideText } from '../helpers/utils';

const PasswordFieldset = ({ getFieldProps, t }) => {
  const { blokkendoos } = React.useContext(AppContext);

  const isUniversity =
    blokkendoos.getSignupFor() === SIGNUP_FOR_MAPPING.university;

  return (
    <>
      <TextInput
        label={t('fieldset_password.password_label')}
        type='password'
        {...getFieldProps('password')}
        tooltipContent={whenFieldHasValueHideText(
          getFieldProps('password').value,
          t('fieldset_password.password_tooltip')
        )}
        isRequired
        hoverTooltipProps={{ noHover: true }}
      />
      {isUniversity && (
        <p className='mt-1x'>{t('fieldset_password.comment')}</p>
      )}
    </>
  );
};

PasswordFieldset.type = 'password';

PasswordFieldset.propTypes = FIELDSET_PROPTYPES;

PasswordFieldset.initialValues = () => ({
  password: ''
});

PasswordFieldset.validationSchema = () => ({
  password: validPassword().required()
});

export default asFieldset(PasswordFieldset);
